import fetchModels from "../../mixin/store/api/fetchModels";
import pushModel from "../../mixin/store/api/pushModel";
import changeModel from "@/mixin/store/api/changeModel";
import changeOrPushModel from "@/mixin/store/api/changeOrPushModel";

export default {
    actions: {
        fetchProductsInWarehouses(context, page) {
            return fetchModels(context, 'product_in_warehouses?amount[gt]=0', page, 'updateProductsInWarehouses')
        },
        fetchAllProductsInWarehouses(context) {
            if (context.state.productsInWarehouses.isNeedFetch) {
                return fetchModels(context, 'product_in_warehouses?amount[gt]=0', null, 'updateProductsInWarehouses')
            }
        },
        fetchAllProducts(context){
            return fetchModels(context, 'product_in_warehouses/all?pagination=false', null, 'updateAllProductsInWarehouse')
        },
        fetchSoldOutProductsInWarehouses(context) {
            return fetchModels(context, 'product_in_warehouses?amount[lte]=0', null, 'updateSoldProductsInWarehouses')
        },
        fetchProductsIsNotify(context, page = 1) {
            return fetchModels(context, 'product_in_warehouses/notify', page, 'updateProductsIsNotify')
        },
        fetchProductsExpired(context) {
            return fetchModels(context, 'product_in_warehouses/expired', null, 'updateProductsExpired')
        },
        fetchProductsExpirationDateNear(context) {
            return fetchModels(context, 'product_in_warehouses/expirationDateNear', null, 'updateProductsExpirationDateNear')
        },
        pushProductInWarehouseMakeWriteOff(context, data) {
            return pushModel(context, 'product_in_warehouses/make_write_off', data)
        },
        pushProductInWarehouseProductResidue(context, data) {
            return changeOrPushModel(context, 'product_in_warehouses/product_residue', data, 'updateProductResidue')
        },
        putProductInWarehouseIsNotify(context, data) {
            return changeModel(context, 'product_in_warehouses/' + data.id, data,)
        },
        searchProductInWarehouse(context, searchItem) {
            let url = "product_in_warehouses?amount[gt]=0";

            if (searchItem.productName) {
                url = url + '&product.name=' + searchItem.productName
            }

            if (searchItem.barCode) {
                url = url + '&product.barCode=' + searchItem.barCode
            }

            if (searchItem.warehouseName) {
                url = url + '&warehouse.name=' + searchItem.warehouseName
            }

            if (searchItem.warehouseId) {
                url = url + '&warehouse.id=' + searchItem.warehouseId
            }

            if (searchItem.minAmount) {
                url = url + '&amount[gte]=' + searchItem.minAmount
            }

            if (searchItem.maxAmount) {
                url = url + '&amount[lte]=' + searchItem.maxAmount
            }

            if (searchItem.category) {
                url = url + '&product.categories=' + searchItem.category
            }

            return fetchModels(context, url, searchItem.page, 'updateProductsInWarehouses')
        },
        searchProductInWriteOff(context, searchItem) {
            let url = "product_write_offs?";
            let isSearch = false;

            if (searchItem.productName) {
                url = url + '&product.product.name=' + searchItem.productName
                isSearch = true
            }

            if (searchItem.warehouseName) {
                url = url + '&product.warehouse.name=' + searchItem.warehouseName
                isSearch = true
            }

            if (searchItem.warehouseId) {
                url = url + '&warehouse.id=' + searchItem.warehouseId
                isSearch = true
            }

            if (searchItem.minAmount) {
                url = url + '&amount[gte]=' + searchItem.minAmount
                isSearch = true
            }

            if (searchItem.maxAmount) {
                url = url + '&amount[lte]=' + searchItem.maxAmount
                isSearch = true
            }

            if (searchItem.category) {
                url = url + '&product.product.categories=' + searchItem.category
                isSearch = true
            }

            if (!isSearch) {
                url += "&order[id]=desc"
            }

            return fetchModels(context, url, searchItem.page, 'updateProductsInWarehousesWriteOffs')
        },
        changeWarehouseProducts(context, data) {
            return pushModel(context, 'product_in_warehouses/change_warehouse', data);
        },
        makeName(context) {
            if (context.state.productsInWarehouses.models.length) {
                // if (context.state.productsInWarehouses.models[0].name === undefined) {
                    context.state.productsInWarehouses.models.forEach((piw) => {
                        piw.name = piw.product.name + ' (' + piw.amount + ') ' + piw.product.unitOfMeasure
                    })
                // }
            }
        }
    },
    mutations: {
        updateProductsInWarehouses(state, data) {
            state.productsInWarehouses = data
            state.productsInWarehouses.isNeedFetch = false
        },
        updateProductsInWarehousesIDB(state, data) {
            state.productsInWarehouses.models = data
        },
        updateAllProductsInWarehouse(state, data) {
            state.allProductsInWarehouses = data
        },
        updateSoldProductsInWarehouses(state, data) {
            state.soldProductsInWarehouses = data
        },
        updateProductsIsNotify(state, data) {
            state.productsIsNotify = data
        },
        updateProductsExpired(state, data) {
            state.productsExpired = data
        },
        updateProductsExpiredWriteOff(state, data) {
            state.productsExpiredWriteOff.expiredProducts = data
        },
        updateProductsExpirationDateNear(state, data) {
            state.productsExpirationDateNear = data
        },
        updateProductResidue(state, data) {
            state.productResidue.models = data
        },
        updateProductsInWarehousesWriteOffs(state, data) {
            state.productsInWarehousesWriteOffs = data
        },
    },
    state: {
        allProductsInWarehouses: {
            models: [],
            totalItems: 0,
        },
        productsInWarehouses: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        soldProductsInWarehouses: {
            models: [],
            totalItems: 0,
        },
        productsIsNotify: {
            models: [],
            totalItems: 0,
        },
        productsExpired: {
            models: [],
            totalItems: 0,
        },
        productsExpiredWriteOff: {
            expiredProducts: [],
        },
        productsExpirationDateNear: {
            models: [],
            totalItems: 0,
        },
        productResidue: {
            models: [],
            totalItems: 0,
        },
        productsInWarehousesWriteOffs: {
            models: [],
            totalItems: 0,
        },
    },
    getters: {
        getProductsInWarehouse: (state, getters) => (id) => {
            return getters.getProductsInWarehouses.find(model => model.id === id)
        },
        getAllProductsInWarehouses(state) {
            return state.allProductsInWarehouses.models
        },
        getProductsInWarehouses(state) {
            return state.productsInWarehouses.models
        },
        getSoldProductsInWarehouses(state) {
            return state.soldProductsInWarehouses.models
        },
        getProductsIsNotify(state) {
            return state.productsIsNotify.models
        },
        getProductsIsNotifyTotalCount(state) {
            return state.productsIsNotify.totalItems
        },
        getProductsExpired(state) {
            return state.productsExpired.models
        },
        getProductsExpiredWriteOff(state) {
            return state.productsExpiredWriteOff.expiredProducts
        },
        getProductsExpirationDateNear(state) {
            return state.productsExpirationDateNear.models
        },
        getProductResidues(state) {
            return state.productResidue.models
        },
        getProductsExpiredTotalCount(state) {
            return state.productsExpired.totalItems
        },
        getProductsExpirationDateNearTotalCount(state) {
            return state.productsExpirationDateNear.totalItems
        },
        getProductsInWarehousesWriteOffs(state) {
            return state.productsInWarehousesWriteOffs.models
        },
        getProductsInWarehousesWriteOffsTotalCount(state) {
            return state.productsInWarehousesWriteOffs.totalItems
        },
        getProductsInWarehousesTotalCount(state) {
            return state.productsInWarehouses.totalItems
        }
    },
}
